import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';
import { Picture } from 'components';
import { DetailsList } from '../DetailsList';
import { getDays } from '../../util';

import { offerAccumulatorsShape } from '../../../propTypes';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const DetailsBlock = ({ title, period, accumulators, icon }) => (
  <div className={cn('details-block')}>
    <div>
      {title
        && (
          <div className={cn('details-block__title')}>
            <Text size="size7-r">
              {title}
            </Text>
          </div>
        )}
      {period
        && (
          <div className={cn('details-block__period')}>
            <Text size="size5-b" color="sienna">
              {'На '}
              {period}
              {' '}
              {getDays(period)}
            </Text>
          </div>
        )}
      <DetailsList items={accumulators} />
    </div>
    {icon
      && (
        <Picture
          defaultImage={icon}
          alt=""
        />
      )}
  </div>
);

DetailsBlock.propTypes = {
  title: PropTypes.string,
  period: PropTypes.number,
  icon: PropTypes.string,
  accumulators: PropTypes.arrayOf(offerAccumulatorsShape),
};

export { DetailsBlock };
